import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { openFile, byteSize, Translate, TextFormat, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './activity-faq.reducer';

export const ActivityFaq = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search)
  );

  const activityFaqList = useAppSelector(state => state.activityFaq.entities);
  const loading = useAppSelector(state => state.activityFaq.loading);
  const totalItems = useAppSelector(state => state.activityFaq.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    } else {
      return order === ASC ? faSortUp : faSortDown;
    }
  };

  return (
    <div>
      <h2 id="activity-faq-heading" data-cy="ActivityFaqHeading">
        <Translate contentKey="activitiesApp.activityFaq.home.title">Activity Faqs</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="activitiesApp.activityFaq.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/activity-faq/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="activitiesApp.activityFaq.home.createLabel">Create new Activity Faq</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {activityFaqList && activityFaqList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="activitiesApp.activityFaq.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('question')}>
                  <Translate contentKey="activitiesApp.activityFaq.question">Question</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('question')} />
                </th>
                <th className="hand" onClick={sort('asnwer')}>
                  <Translate contentKey="activitiesApp.activityFaq.asnwer">Asnwer</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('asnwer')} />
                </th>
                <th className="hand" onClick={sort('faqNote')}>
                  <Translate contentKey="activitiesApp.activityFaq.faqNote">Faq Note</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('faqNote')} />
                </th>
                <th className="hand" onClick={sort('createdDate')}>
                  <Translate contentKey="activitiesApp.activityFaq.createdDate">Created Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdDate')} />
                </th>
                <th className="hand" onClick={sort('modifiedDate')}>
                  <Translate contentKey="activitiesApp.activityFaq.modifiedDate">Modified Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedDate')} />
                </th>
                <th className="hand" onClick={sort('faqImage')}>
                  <Translate contentKey="activitiesApp.activityFaq.faqImage">Faq Image</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('faqImage')} />
                </th>
                <th>
                  <Translate contentKey="activitiesApp.activityFaq.activity">Activity</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {activityFaqList.map((activityFaq, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/activity-faq/${activityFaq.id}`} color="link" size="sm">
                      {activityFaq.id}
                    </Button>
                  </td>
                  <td>{activityFaq.question}</td>
                  <td>{activityFaq.asnwer}</td>
                  <td>{activityFaq.faqNote}</td>
                  <td>
                    {activityFaq.createdDate ? <TextFormat type="date" value={activityFaq.createdDate} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>
                    {activityFaq.modifiedDate ? <TextFormat type="date" value={activityFaq.modifiedDate} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>
                    {activityFaq.faqImage ? (
                      <div>
                        {activityFaq.faqImageContentType ? (
                          <a onClick={openFile(activityFaq.faqImageContentType, activityFaq.faqImage)}>
                            <img
                              src={`data:${activityFaq.faqImageContentType};base64,${activityFaq.faqImage}`}
                              style={{ maxHeight: '30px' }}
                            />
                            &nbsp;
                          </a>
                        ) : null}
                        <span>
                          {activityFaq.faqImageContentType}, {byteSize(activityFaq.faqImage)}
                        </span>
                      </div>
                    ) : null}
                  </td>
                  <td>
                    {activityFaq.activity ? <Link to={`/activity/${activityFaq.activity.id}`}>{activityFaq.activity.name}</Link> : ''}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/activity-faq/${activityFaq.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/activity-faq/${activityFaq.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/activity-faq/${activityFaq.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="activitiesApp.activityFaq.home.notFound">No Activity Faqs found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={activityFaqList && activityFaqList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default ActivityFaq;
